import React from 'react';
import C from '../colors';

export default function CustomPagination({ count, page, onChange }) {
  if (count <= 1) return null;

  const pages = [];
  const maxVisible = 5;
  let start = Math.max(1, page - Math.floor(maxVisible / 2));
  let end = Math.min(count, start + maxVisible - 1);
  if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);

  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
      <button data-testid="pagination-prev" disabled={page <= 1} onClick={() => onChange(null, page - 1)} style={btnStyle(page <= 1)}>←</button>
      {start > 1 && <span style={{ padding: '0 4px', color: C.ink3, fontFamily: C.mono, fontSize: 11 }}>…</span>}
      {pages.map(p => (
        <button data-testid={`pagination-page-${p}`} key={p} onClick={() => onChange(null, p)} style={p === page ? activeBtnStyle : btnStyle(false)}>
          {p}
        </button>
      ))}
      {end < count && <span style={{ padding: '0 4px', color: C.ink3, fontFamily: C.mono, fontSize: 11 }}>…</span>}
      <button data-testid="pagination-next" disabled={page >= count} onClick={() => onChange(null, page + 1)} style={btnStyle(page >= count)}>→</button>
    </div>
  );
}

const btnStyle = (disabled) => ({
  minWidth: 34, height: 34, borderRadius: 7,
  border: `1px solid ${C.hair2}`,
  background: disabled ? C.paper2 : '#fff',
  color: disabled ? C.hair2 : C.ink2,
  fontFamily: C.sans, fontSize: 13, fontWeight: 500,
  cursor: disabled ? 'default' : 'pointer',
  display: 'grid', placeItems: 'center',
});

const activeBtnStyle = {
  ...btnStyle(false),
  background: C.ink, color: '#fff', borderColor: C.ink,
};
